import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) => ({
  rootWrapper: {
    position: "relative",
    width: "100%",
  },
  inputAndButtonContainer: {
    display: "flex",
    width: "100%",
    height: "95%",
    borderRadius: "4px",
    color: "rgba(0, 0, 0, 0.87)",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    fontSize: "16px",
    "&:focus-visible": {
      outline: "none",
      borderWidth: "1px",
      borderColor: theme.primary500,
    },
    "&:hover": {
      borderColor: "rgba(0, 0, 0, 0.87)",
    },
  },
  error: { borderColor: theme.red500 },
  label: {
    display: "block",
  },
  inputDialog: {
    width: "100%",
  },
  inputAutocomplete: {
    flex: "1 0 auto",
    width: "100%",
    height: "100%",
    padding: "18.5px 14px",
    borderRadius: "4px",
    fontSize: "16px",
    border: "none",
    "&:focus-visible": {
      outline: "none",
    },
  },
  plusButton: {
    backgroundColor: "#E5E5E5",
    borderRadius: "0 4px 4px 0",
    margin: 0,
    "&:hover": {
      backgroundColor: "#E5E5E5",
    },
  },
  plusIcon: {
    fontSize: "22px!important",
    marginLeft: "10px",
    color: theme.gray500,
  },
  listbox: {
    margin: "0 40px 0 0",
    width: "100%",
    padding: 0,
    zIndex: 1,
    position: "absolute",
    left: "0",
    listStyle: "none",
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
    maxHeight: 200,
    border: "1px solid rgba(0,0,0,.25)",
    '& li[data-focus="true"]': {
      backgroundColor: "#0000000A",
      cursor: "pointer",
    },
    "& li:active": {
      backgroundColor: "#2977f5",
      color: theme.white50,
    },
  },
  modalButton: {
    marginTop: theme.spacing(12),
  },
  modalInput: {
    maxWidth: "100%",
    width: 406,
    "& + &": { marginTop: theme.spacing(10) },
  },
  nestedInput: { width: "100%" },
  input: {
    "& input": {
      backgroundColor: theme.white50,
    },

    width: "100%",
  },
}));
